<template>
  <Head :title="title ? `${title} - OrthoMatrix` : 'OrthoMatrix'">
    <slot />
  </Head>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Head,
  },
  props: {
    title: String,
  },
}
</script>